<div class="card" [ngClass]="{'card-expand':fullScreen, 'bg-emphasis':!fullScreen}">
  <div class="card-body">

    <div class="d-flex fw-bold small mb-2 text-truncate text-uppercase">
      <span class="flex-grow-1">{{widget.name}}</span>
      <a class="text-default text-opacity-50 text-decoration-none" (click)="refresh()" data-bs-original-title="" title=""><i class="bi bi-arrow-repeat"></i></a>
      <a data-toggle="card-expand" class="text-default text-opacity-50 text-decoration-none" (click)="toggleFullScreen()" data-bs-original-title="" title=""><i class="bi bi-fullscreen"></i></a>
    </div>

    <div class="windrose">
      <highcharts-chart
        *ngIf="isConfigured; else notConfigured"
        [Highcharts]="Highcharts"

        [options]="chartOptions"
        [callbackFunction]="chartCallback"
      
        [(update)]="updateFlag"
        [oneToOne]="oneToOneFlag"
        style="width: 100%;"
      ></highcharts-chart> 
      
      <ng-template #notConfigured>
        <p class="not-configured">Wind Rose Not Configured</p>
      </ng-template>

    </div>
  </div>
</div>